module.exports = __webpack_public_path__ + "media/images/global/icons/photo-b346eb0b6be56af0785c08e0d056d651.svg";